export const getSelectedIds = (obj, isNumber = true) => {
  const selected = Object.keys(obj).filter((item) => !!obj[item]);
  if (isNumber) return selected.map((item) => +item);
  return selected;
};

export const toValidComponentDate = (date, withTime = false) => {
  if (!date) return "";
  if (typeof date === "object") return date;
  try {
    let dateParts = date.split(".");
    if (dateParts?.length !== 3) {
      return date;
    }
    let day = dateParts[0];
    let month = dateParts[1];
    let year = dateParts[2];
    let time = "";

    const yearSplited = year.split(" ");
    if (yearSplited?.length > 1) {
      year = yearSplited[0].trim();
      time = yearSplited[1].trim();
    }
    return `${year}-${month}-${day}${withTime && !!time ? ` ${time}` : ""}`;
  } catch (e) {
    return "";
  }
};

export const checkIdValid = (id) => {
  if (!id) return;
  if (isNaN(id)) throw "Введите корректный ID";
};

export const cropWord = (word = "", maxLength = 25, defaultStr = "") => {
  if (!word) return defaultStr;
  try {
    const cropped = word.slice(0, maxLength);
    if (word?.length > maxLength) return `${cropped}...`;
    return cropped;
  } catch (e) {
    return defaultStr;
  }
};
export const isFileImg = (ext) => {
  return ext === "jpg" || ext === "png" || ext === "jpeg";
};
export const isFileVideo = (ext) => {
  if (!ext) return false;
  const videoExtensions = [
    ".mp4",
    ".avi",
    ".mkv",
    ".mov",
    ".wmv",
    ".flv",
    ".webm",
    ".mpeg",
  ];
  return videoExtensions.includes(`.${ext.toLowerCase()}`);
};

export const getFileExt = (fileName) => {
  if (!fileName) return "";
  if (!fileName?.includes(".")) return "";
  const splited = fileName?.split(".")?.filter((item) => !!item);
  return splited[splited.length - 1];
};
export const isValidDate = (dateString) => {
  const dateObject = new Date(dateString);
  return !isNaN(dateObject.getTime());
};

export const isDotFormatDate = (date) => {
  if (!date) return false;
  return (
    (date?.length === 10 || date?.length === 16 || date?.length === 19) &&
    (date.match(/\./g) || []).length === 2
  );
};
